import {
  Alert,
  ChakraBox,
  ChakraFlex,
  ChakraText,
  Close,
  EquipUIFireflyV2Theme,
} from '@equip.health/ui';

import {
  GLOBAL_GENERIC_ERROR_TEXT,
  SUPPORT_EMAIL,
} from '~/lib/constants/global.constants';
import {
  PortalComponent,
  useComponentPortalContext,
} from '~/lib/contexts/ComponentPortalContext';

const TOP_LEVEL_ID = 'global-error-toast';

const { body, bodySemibold } = EquipUIFireflyV2Theme.typography;
const {
  neutral: { secondary: neutralSecondary },
  critical,
} = EquipUIFireflyV2Theme.colors;

interface GlobalErrorToastProps {
  show: boolean;
  statusCode: number;
}

// We need to decide if we want to use this or createToastMessage()
const GlobalErrorToast = ({ show, statusCode }: GlobalErrorToastProps) => {
  const { setComponentVisibility } = useComponentPortalContext();

  const onClose = (): void => {
    setComponentVisibility({
      component: PortalComponent.ERROR_TOAST,
      data: null,
      isVisible: false,
    });
  };

  if (!show) return null;

  return (
    <ChakraFlex
      bottom="0px"
      id={TOP_LEVEL_ID}
      justifyContent="center"
      left="0px"
      paddingBottom="30px"
      position="fixed"
      width="100%"
    >
      <ChakraFlex
        alignItems="center"
        background="critical.background"
        borderRadius="10px"
        id={`${TOP_LEVEL_ID}__content`}
        padding="12px 16px"
      >
        <Alert fill={critical.base} height="16px" width="16px" />
        <ChakraText
          color="critical.base"
          paddingLeft="10px"
          {...bodySemibold}
          id={`${TOP_LEVEL_ID}__status-text`}
        >
          {`Error (${statusCode})`}
        </ChakraText>
        <ChakraText
          {...body}
          color="neutral.secondary"
          id={`${TOP_LEVEL_ID}__message-text`}
          paddingX="20px"
        >
          <ChakraText as="span">{`${GLOBAL_GENERIC_ERROR_TEXT} `}</ChakraText>
          <ChakraText
            as="a"
            href={`mailto:${SUPPORT_EMAIL}`}
            textDecoration="underline"
          >
            {SUPPORT_EMAIL}
          </ChakraText>
        </ChakraText>
        <ChakraBox cursor="pointer" onClick={onClose}>
          <Close fill={neutralSecondary} height="16px" width="16px" />
        </ChakraBox>
      </ChakraFlex>
    </ChakraFlex>
  );
};

export default GlobalErrorToast;
